import { Tag } from "primereact/tag";
import { useGetCategoryQuery } from "../store/api/directory/categoryApi"
import { getStatus } from "./partial";


export const buyForMeColumn = [
    {
        attr: "guid",
        labelKey: "guid",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "status",
        labelKey: "status",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "phone",
        labelKey: "phone",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "email",
        labelKey: "email",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "name",
        label: "productName",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "country",
        labelKey: "country",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "tracking_number",
        label: "tracking_number",
        type: 2,
        opt: 2,
        hidden: false,
        editor: false
    },
    {
        attr: "created_at",
        label: "date_create",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData) => {
            return new Date(rowData.created_at).toLocaleString()
        }
    },

    {
        attr: "category",
        attr_en: "category_en",
        labelKey: "category",
        type: 1,
        hidden: false,
        editor: false
    },
    {
        attr: "comment",
        labelKey: "comment",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "price",
        label: "price",
        type: 2,
        opt: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "currency_guid",
        label: "currency_guid",
        type: 3,
        opt: 2,
        hidden: true,
        editor: true
    },
    {
        attr: "amount",
        label: "count",
        type: 2,
        opt: 2,
        hidden: false,
        editor: false
    },
    {
        attr: "link",
        label: "linkProduct",
        type: 1,
        opt: 6,
        optionLabel: "email",
        optionValue: "guid",
        hidden: false,
        editor: false
    },
    {
        attr: "client",
        labelKey: "client",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "country_guid",
        labelKey: "country_guid",
        type: 3,
        opt: 5,
        optionLabel: "country",
        optionValue: "guid",
        hidden: true,
        editor: false
    },
    {
        attr: "invoice",
        labelKey: "invoice",
        type: 5,
        hidden: true,
        editor: true
    },
    {
        attr: "access_confirm",
        labelKey: "access_confirm",
        type: 1,
        hidden: false,
        editor: false,
        body: (rowData, trans) => {
            return <Tag value={trans(getStatus(rowData.status).text)} severity={getStatus(rowData.status).variant} />;
        }
    }
]

